// extracted by mini-css-extract-plugin
module.exports = {"mapSwitchIcon":"sitesList_mapSwitchIcon__2tlgP","map":"sitesList_map__33Pia","actionButton":"sitesList_actionButton__3NRzu"};